











import Vue from "vue";
import { DocumentFieldValue } from "@infoland/iprova-api";
export default Vue.extend({
    name: "LinkedDocumentsField",
    components: {},
    props: {
        values: { type: Array as () => DocumentFieldValue[] }
    },
    data: function () {
        return {
            linkedDocuments: [] as DocumentFieldValue[]
        };
    },
    methods: {},
    watch: {
        values: {
            handler(newValues: DocumentFieldValue[]) {
                this.linkedDocuments = [
                    ...newValues.reduce((items, item) => (items.find(i => i.id === item.id) ? [...items] : [...items, item]), [])
                ].sort((a, b) => a.value.localeCompare(b.value));
            },
            immediate: true
        }
    }
});
